import _ from 'lodash'
import { FETCHING, FETCHED, OUTDATED, LOCALE_CHANGED } from './constants'

const initialState = { locale: 'en', locales: {} }

// sample state:
// const x = {
//     locale: 'en',
//     locales: {
//         en: {
//             fetching: false,
//             outdated: false,
//             news: [
//                 {
//                     title: 'some news title',
//                     link: 'link to the news',
//                     published: 'date published',
//                 },
//             ],
//         },
//     },
// }

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // Let the state now that we are currently fetching
        case FETCHING: {
            const locale = action.payload
            const locales = _.cloneDeep(state.locales)
            if (locales[locale] === undefined) {
                // This is a new language...
                locales[locale] = {
                    fetching: true,
                    outdated: false,
                    news: [],
                }
            } else {
                locales[locale].fetching = true
                locales[locale].outdated = false
            }

            return { ...state, locales }
        }

        // Update the state with new news
        case FETCHED: {
            const { locale, news } = action.payload
            const locales = _.cloneDeep(state.locales)
            if (locales[locale] == null) {
                locales[locale] = {
                    fetching: false,
                    outdated: false,
                    news,
                }
            } else {
                // If outdated is true, then it was set to true
                // after we started fetching and thus we might have
                // outdated news...
                locales[locale] = {
                    fetching: false,
                    news,
                }
            }

            return { ...state, locales }
        }

        // Mark the data as outdated
        case OUTDATED: {
            let locales = _.cloneDeep(state.locales)
            locales = _.mapValues(locales, (v) => {
                v.outdated = true
                return v
            })

            return { ...state, locales }
        }

        // Locale changed
        case LOCALE_CHANGED: {
            const locales = _.cloneDeep(state.locales)
            return {
                locale: action.payload,
                locales,
            }
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/News/data/feed/reducers.js